import React from "react";
import PropTypes from "prop-types";
import Amplify, { Auth } from "aws-amplify";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withAlert } from "react-alert";
import {
  getSettlemetEnrichmentQuestion,
  getEnrollSettlementForUser,
  getAlLFeatureSettlement,
  saveEnrichmentAnswer,
  getAllCategory,
  getAllEnrolledSettlement,
  clearDataEnrollment
} from "../../Actions/actions";
import * as SecretKeys from "../../ENV.json";
import EnrollmentListComponent from "./enrollmentListComponent";
import loader from "../../images/Spin-1s-107px.gif";

Amplify.configure(SecretKeys.awsUserpool);

class EnrollmentListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSettlementData: {},
      selectedMenuItem: "dashboard",
      userid: localStorage.getItem("userId"),
      isLoader: false,
      // response: false,
      intervalId: 0
    };
    this.saveEnrichmentAnswer = this.saveEnrichmentAnswer.bind(this);
  }

  /**
   * Get users Details
   */
  componentDidMount() { }

  /**
   * Get all Fetures settlements
   * Gel all Enrolled Settlements
   * Get enrolled settlement for users
   * Get all category
   * Get all settlement enriched questions
   */
  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending'
        && !!localStorage.getItem('paymentFailedButLetUserIn') === false) {
      this.context.router.history.push('/add-payment-method');
    }
    // if (localStorage.getItem("paymentStatus") === "pending") {
    //   // localStorage.clear();
    //   Auth.signOut()
    //     .then(async () => {
    //       // await this.props.logoutUser();
    //       // this.props.clearDataEmail();
    //       this.context.router.history.push("/");
    //     })
    //     .catch(error => error);
    // }
    const userObject = JSON.parse(localStorage.getItem("userObject"));
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    if (userObject) {
      if (typeof userObject.userDto !== "undefined") {
        if (typeof userObject.userDto.roleName !== "undefined") {
          if (userObject.userDto.roleName === "Affiliate") {
            this.context.router.history.push("/affiliate");
            // if(userObject.userDto.parentAffiliateUser === "Yes"){
            //   router.history.push("/parent-affiliate");
            // }else{
            //   router.history.push("/affiliate");
            // }
          }
        }
      }
    }
    // this.props.getAlLFeatureSettlement({ userId: this.state.userid });
    this.props.getAllEnrolledSettlement({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      catgoryId: 0,
      sortBy: "",
      userId: this.state.userid
    });
    // this.props.getEnrollSettlementForUser({ settlementStatusType: 'In Progress', userId: this.state.userid });
    this.props.getSettlemetEnrichmentQuestion({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: ""
    });
    this.props.getAllCategory({ searchKeyword: "" });
    this.setState({
      isLoader: true,
      intervalId
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState || this.props !== nextProps) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    // const settleRecord = nextProps.data.setEnrolledFilteredSettlement;
    // const enrollSettleForUser = nextProps.data.EnrollSettlementForUser;
    const AllCategory = nextProps.data.AllCategory;
    this.setState({
      // allSettlementData: settleRecord,
      // enrollSettlementForUser: enrollSettleForUser,
      AllCategoryData: AllCategory
    });

    // if (this.state.isLoader === true) {
    //   this.setState({
    //     response: true
    //   });
    // }
  }
  componentDidUpdate() {
    const {
      data: { setEnrolledFilteredSettlement }
    } = this.props;
    const { allSettlementData } = this.state;
    if (
      setEnrolledFilteredSettlement.totalCount !== undefined ||
      setEnrolledFilteredSettlement.code !== undefined
    ) {
      if (allSettlementData !== setEnrolledFilteredSettlement) {
        this.setState({
          allSettlementData: setEnrolledFilteredSettlement,
          isLoader: false
        });
      }
    }
  }

  /**
   * Save Question Answer
   */
  saveEnrichmentAnswer(queId, ans) {
    const data = {
      userId: this.state.userid,
      value: ans,
      enrichmentQuestionId: queId
    };
    this.props.saveEnrichmentAnswer(data);
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  componentWillUnmount() {
    this.props.clearDataEnrollment();
  }

  render() {
    const {
      selectedMenuItem,
      allSettlementData,
      // enrollSettlementForUser,
      AllCategoryData,
      isLoader
      // response
    } = this.state;
    let loader1;


    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    return (
      <div className="container">
        {loader1}
        <div className="main-content bg-grey">
          <EnrollmentListComponent
            allSettlementDatawe={allSettlementData}
            // enrollSettlementForUser={enrollSettlementForUser}
            selectedMenuItem={selectedMenuItem}
            allCategoryDatawe={AllCategoryData}
            isLoader={isLoader}
          // response={response}
          />
        </div>
      </div>
    );
  }
}

EnrollmentListContainer.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettlemetEnrichmentQuestion,
      getEnrollSettlementForUser,
      getAlLFeatureSettlement,
      saveEnrichmentAnswer,
      getAllCategory,
      getAllEnrolledSettlement,
      clearDataEnrollment
    },
    dispatch
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EnrollmentListContainer)
);
